module.exports = __webpack_public_path__ + "src/assets/img/page2/f75cbc0ae784cdcc60f9923dedf9498f.png";